import { texts } from '../../locale'
import { theme } from '../../../styles/theme'
import imgUrl1 from './../assets/01.webp'
import imgUrl2 from './../assets/02.webp'
import imgUrl3 from './../assets/03.webp'
import imgUrl4 from './../assets/04.webp'
import { Title, Grid, Woman, Bubble } from './styled'

const AllTogether = () => {
  return (
    <div>
      <Title>{texts.allTogether_1}</Title>
      <Grid>
        <Woman>
          <div>
            <Bubble $dir="left">
              {texts.allTogether_2}
              <svg viewBox="0 0 120 78" className="horizontal">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M120 0, 0 39, 120 78"
                />
              </svg>
              <svg viewBox="0 0 78 120" className="vertical">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 10 120, 78 0"
                />
              </svg>
            </Bubble>
          </div>
          <div className="img-container">
            <img src={imgUrl1} />
          </div>
        </Woman>
        <Woman>
          <div>
            <Bubble $dir="right">
              {texts.allTogether_3}
              <svg viewBox="0 0 120 78" className="horizontal">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 120 39, 0 78"
                />
              </svg>
              <svg viewBox="0 0 78 120" className="vertical">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 10 120, 78 0"
                />
              </svg>
            </Bubble>
          </div>
          <div className="img-container">
            <img src={imgUrl2} />
          </div>
        </Woman>
        <Woman>
          <div>
            <Bubble $dir="left">
              {texts.allTogether_4}{' '}
              <svg viewBox="0 0 120 78" className="horizontal">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M120 0, 0 39, 120 78"
                />
              </svg>
              <svg viewBox="0 0 78 120" className="vertical">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 10 120, 78 0"
                />
              </svg>
            </Bubble>
          </div>
          <div className="img-container">
            <img src={imgUrl3} />
          </div>
        </Woman>
        <Woman>
          <div>
            <Bubble $dir="right">
              {texts.allTogether_5}
              <svg viewBox="0 0 120 78" className="horizontal">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 120 39, 0 78"
                />
              </svg>
              <svg viewBox="0 0 78 120" className="vertical">
                <path
                  fill={theme.colors.background}
                  stroke={theme.colors.text}
                  strokeWidth="1px"
                  vectorEffect="non-scaling-stroke"
                  d="M0 0, 10 120, 78 0"
                />
              </svg>
            </Bubble>
          </div>
          <div className="img-container">
            <img src={imgUrl4} />
          </div>
        </Woman>
      </Grid>
    </div>
  )
}
export default AllTogether
